import React from 'react';
import { useForm } from 'react-hook-form';

import NButton from '../NButton';
import NInput from '../NInput';

import { Container, Form } from './styles';

const NModalAddAddress = ({ save, label, streetProp, ...rest }) => {
  const { register, handleSubmit, watch } = useForm();

  const submit = () => {
    const street = watch('street');
    const references = watch('reference');
    if (street) save({ name: street, reference: references });
    else save({ name: streetProp, reference: references });
  };

  return (
    <Container {...rest}>
      <p className="title">{label}</p>
      <Form onSubmit={handleSubmit(submit)}>
        {!streetProp && (
          <NInput
            label="Rua"
            placeholder="Escreva o nome da rua."
            {...register('street', { required: true })}
          />
        )}

        <NInput
          label="Detalhes do endereço:"
          placeholder="Digite aqui..."
          {...register('reference', { required: true })}
        />
        <NButton className="button" label="Confirmar" type="submit" />
      </Form>
      <p className="helper">Escreva um ponto de referencia, número etc.</p>
    </Container>
  );
};

export default NModalAddAddress;
